import axios from "axios";
import { ZOHO_SCOPES } from "../../config/scope";
import {
  ADMIN_API_URL,
  DATA_CENTER_API_NAME,
  DATA_CENTER_URL_API_NAME,
  Default_Authenticator_API_NAME,
  EXTENSION_IDENTIFIER,
  IS_SANDBOX,
  ORG_ID_API_NAME,
  SERVICE_API_URL,
} from "../../config/serviceConstant";
import {
  accountUrlMap,
  dataCenterMap,
  RELATEDLIST_WIDGET_TYPE,
  WIDGET_DESCRIPTION,
  WIDGET_NAME,
  WIDGET_URL,
} from "../../config/zohoConstant";
import { getValue, setValue } from "./ApiCalling";

export const setOrgId = async (ZOHO) => {
  try {
    const orgInfo = await ZOHO.CRM.CONFIG.getOrgInfo();
    const orgId = orgInfo?.org?.[0]?.id || "";
    const orgData = {
      apiname: ORG_ID_API_NAME,
      value: orgId,
    };
    await ZOHO.CRM.CONNECTOR.invokeAPI("crm.set", orgData);
    return orgId;
  } catch (error) {
    return error;
  }
};

export const setUpOrgVariable = async (ZOHO, variableKey, variableValue) => {
  try {
    const orgData = {
      apiname: variableKey,
      value: variableValue,
    };
    let test = await ZOHO.CRM.CONNECTOR.invokeAPI("crm.set", orgData);
    return true;
  } catch (error) {
    return false;
  }
};

export const setUpDataCenterUrl = async (ZOHO) => {
  try {
    const currentEnv = await ZOHO.CRM.CONFIG.GetCurrentEnvironment();
    let dataCenterUrl = dataCenterMap?.[currentEnv?.deployment] || "";
    if (IS_SANDBOX === "true") {
      dataCenterUrl = `https://plugin-${EXTENSION_IDENTIFIER}.zohosandbox.com`;
    }
    const dataCenterData = {
      apiname: DATA_CENTER_URL_API_NAME,
      value: dataCenterUrl,
    };
    await ZOHO.CRM.CONNECTOR.invokeAPI("crm.set", dataCenterData);
    return dataCenterUrl;
  } catch (error) {
    return null;
  }
};

export const setUpDataCenter = async (ZOHO) => {
  try {
    const currentEnv = await ZOHO.CRM.CONFIG.GetCurrentEnvironment();
    const dataCenterData = {
      apiname: DATA_CENTER_API_NAME,
      value: currentEnv?.deployment,
    };
    await ZOHO.CRM.CONNECTOR.invokeAPI("crm.set", dataCenterData);

    return currentEnv?.deployment;
  } catch (error) {
    return null;
  }
};

export const setUpDefaultAuthenticator = async (ZOHO, email) => {
  try {
    const defaultAuthenticatorData = {
      apiname: Default_Authenticator_API_NAME,
      value: email,
    };
    await ZOHO.CRM.CONNECTOR.invokeAPI("crm.set", defaultAuthenticatorData);

    return true;
  } catch (error) {
    return null;
  }
};

export const getOrgVariable = async (ZOHO, variableKey) => {
  try {
    const variableValue = await ZOHO.CRM.API.getOrgVariable(variableKey);
    return variableValue?.Success?.Content || null;
  } catch (error) {
    return null;
  }
};

export const getOrgVariableList = async (ZOHO, variableKeyList) => {
  const orgid = await getOrgVariable(ZOHO, ORG_ID_API_NAME);
  const uniqueKey = `${orgid}__${EXTENSION_IDENTIFIER}__orgvariables`;
  try {
    const orgVariables = await getValue({ key: uniqueKey });
    if (orgVariables?.data || orgVariables?.data != null) {
      return JSON.parse(orgVariables.data);
    }

    var data = { apiKeys: variableKeyList };
    const variableValue = await ZOHO.CRM.API.getOrgVariable(data);
    let Content = variableValue?.Success?.Content;
    const returnMap = {};
    variableKeyList.forEach((variableKey) => {
      returnMap[variableKey] = Content?.[variableKey]?.value;
    });
    const setOrgVariables = await setValue({
      key: uniqueKey,
      value: JSON.stringify(returnMap),
    });
    return returnMap;
  } catch (error) {
    try {
      var data = { apiKeys: variableKeyList };
      const variableValue = await ZOHO.CRM.API.getOrgVariable(data);
      let Content = variableValue?.Success?.Content;
      const returnMap = {};
      variableKeyList.forEach((variableKey) => {
        returnMap[variableKey] = Content?.[variableKey]?.value;
      });
      const setOrgVariables = await setValue({
        key: uniqueKey,
        value: JSON.stringify(returnMap),
      });
      return returnMap;
    } catch (error) {
      return {};
    }
  }
};

export const getLoginUserData = async (ZOHO) => {
  try {
    let currentUserResp;

    currentUserResp = await ZOHO.CRM.CONFIG.getCurrentUser();
    if (currentUserResp?.users?.[0]?.id) {
      return currentUserResp?.users?.[0];
    }

    await setTimeout(async () => {
      currentUserResp = await ZOHO.CRM.CONFIG.getCurrentUser();
      return;
    }, 3000);

    if (currentUserResp?.users?.[0]?.id) {
      return currentUserResp?.users?.[0];
    }

    await setTimeout(async () => {
      currentUserResp = await ZOHO.CRM.CONFIG.getCurrentUser();
      return;
    }, 3000);

    return currentUserResp?.users?.[0] || null;
  } catch (error) {
    return null;
  }
};

export const getAllUserData = async (ZOHO) => {
  try {
    const usersResp = await ZOHO.CRM.API.getAllUsers({ Type: "AllUsers" });
    return usersResp?.users?.filter((user) => user?.status === "active") || [];
  } catch (error) {
    return null;
  }
};

const getAccountUrl = (countryCode) => {
  return accountUrlMap[countryCode];
};

export const getZohoAuthUrl = async (zohoBody) => {
  try {
    const config = {
      method: "POST",
      url: ADMIN_API_URL + "/auth/zoho/authenticate",
      data: {
        orgId: zohoBody?.orgid,
        apiKey: zohoBody?.apikey,
        zapiKey: zohoBody?.zapikey,
        accountsUrl: getAccountUrl(zohoBody?.dataCenter),
        connName: zohoBody?.connname,
        scope: ZOHO_SCOPES,
        redirectUrl: ADMIN_API_URL + "/auth/zoho/callback",
        crmApiDomain: zohoBody?.datacenterurl,
        role: "Admin",
      },
    };

    const authUrlResp = await axios(config);
    return authUrlResp?.data?.authUrl;
  } catch (error) {
    return null;
  }
};

export const generateAuthUrl = async (zohoBody, role) => {
  try {
    const config = {
      method: "POST",
      url: ADMIN_API_URL + "/auth/zoho/authurl",
      data: {
        orgId: zohoBody?.orgid,
        apiKey: zohoBody?.apikey,
        zapiKey: zohoBody?.zapikey,
        accountsUrl: getAccountUrl(zohoBody?.dataCenter),
        connName: zohoBody?.connname,
        scope: role?.scopes,
        redirectUrl: ADMIN_API_URL + "/auth/zoho/callback",
        crmApiDomain: zohoBody?.datacenterurl,
        role: role?.name || "Admin",
      },
    };

    const authUrlResp = await axios(config);
    return authUrlResp?.data?.authUrl;
  } catch (error) {
    return null;
  }
};

// tokens
export const getTokens = async (body) => {
  try {
    const config = {
      method: "GET",
      url: ADMIN_API_URL + "/db/planetscale/clients/tokens",
      headers: {
        orgid: body?.orgid,
        apikey: body?.apikey,
        connname: body?.connname || `${EXTENSION_IDENTIFIER}__zoho`,
      },
    };

    const authUrlResp = await axios(config);
    return authUrlResp?.data?.tokenResps;
  } catch (error) {
    return null;
  }
};

export const checkZohoAuth = async (zohoHeaders) => {
  try {
    const config = {
      method: "get",
      url: ADMIN_API_URL + "/auth/zoho/verifyauth",
      headers: zohoHeaders,
    };

    const authCheck = await axios(config);

    if (authCheck?.data?.org?.length > 0) {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const verifyZohoAuthAndCreateRelatedListWidget = async (zohoHeaders) => {
  try {
    const config = {
      method: "get",
      url: ADMIN_API_URL + "/auth/zoho/verifyauth",
      headers: zohoHeaders,
    };
    const authCheck = await axios(config);
    if (!authCheck?.data?.org?.length) {
      return { isAuthenticated: false, isRelatedListCreated: false };
    }

    try {
      let config = {
        url: `${ADMIN_API_URL}/data/zoho/crm/extwidgets`,
        method: "POST",
        data: {
          widgetName: WIDGET_NAME,
          widgetUrl: WIDGET_URL,
          widgetDescription: WIDGET_DESCRIPTION,
          widgetType: RELATEDLIST_WIDGET_TYPE,
          apiDomain: zohoHeaders?.datacenterurl,
        },
        headers: zohoHeaders,
      };
      const createExtension = await axios.request(config);
      return { isAuthenticated: true, isRelatedListCreated: true };
    } catch (error) {
      return { isAuthenticated: true, isRelatedListCreated: false };
    }
  } catch (error) {
    return { isAuthenticated: false, isRelatedListCreated: false };
  }
};

export const getZUID = async (zohoHeaders) => {
  try {
    const config = {
      method: "GET",
      url: SERVICE_API_URL + "/getzuid",
      headers: zohoHeaders,
    };

    const zuidResp = await axios(config);
    return zuidResp;
  } catch (error) {
    return null;
  }
};

export const checkExtFolders = async (zuid, zohoHeaders) => {
  try {
    const config = {
      method: "POST",
      url: SERVICE_API_URL + `/${zuid}/extfoldersnew`,
      headers: zohoHeaders,
      data: {},
    };

    const extFolderResp = await axios(config);
    return extFolderResp?.data;
  } catch (error) {
    return null;
  }
};

export const checkExtRelatedListSettings = async (zohoHeaders) => {
  try {
    const config = {
      method: "GET",
      url: SERVICE_API_URL + `/extrelatedsettings`,
      headers: zohoHeaders,
    };

    const extRelatedListSettings = await axios(config);
    return extRelatedListSettings?.data;
  } catch (error) {
    return null;
  }
};

export const revokeZoho = async (zohoHeaders) => {
  try {
    const config = {
      method: "get",
      url: ADMIN_API_URL + "/auth/zoho/revoke",
      headers: zohoHeaders,
    };

    const revokeCheck = await axios(config);
    if (revokeCheck?.data || !revokeCheck?.error) return true;
    return false;
  } catch (error) {
    return false;
  }
};
